import { FC } from "preact/compat";
import { IconButton, MediaViewer } from "~/components";
import ApprovalButton from "./ApprovalButton";
import { PrintViewProps } from "./interfaces";
import ChevronLeftIcon from "@material-design-icons/svg/outlined/chevron_left.svg";
import ChevronRightIcon from "@material-design-icons/svg/outlined/chevron_right.svg";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";

const Desktop: FC<PrintViewProps> = ({
    budget,
    project,
    onClose,
    frozen,
    hasNavigation,
    hasPrev,
    hasNext,
    onPrev,
    onNext,
    finalPdfUrl,
    editorOverlay,
    settingsContent,
    activeIndex,
    viewerRef,
    getParams,
}) => (
    <div className="relative h-[calc(var(--h-main-content)-32px)] flex bg-white rounded-2xl p-4">
        <div className="absolute -right-12 top-0">
            <IconButton title="Close" onClick={onClose}>
                <CloseIcon width="20" height="20" />
            </IconButton>
        </div>
        <div
            style={{
                minWidth:
                    "calc((var(--h-main-content) - 40px) / 1.4142 + 132px)",
            }}
            className="relative w-full bg-gray-100 max-h-[calc(var(--h-main-content)-40px)] rounded-2xl flex gap-x-4 justify-center py-2 px-4"
        >
            {editorOverlay}
            <div className="flex h-full items-center">
                {hasNavigation && (
                    <IconButton
                        title="Previous Page"
                        disabled={!hasPrev}
                        onClick={onPrev}
                    >
                        <ChevronLeftIcon width="20" height="20" />
                    </IconButton>
                )}
            </div>
            <div
                ref={viewerRef}
                className="relative max-h-full overflow-overlay rounded-2xl"
            >
                {finalPdfUrl && (
                    <MediaViewer
                        activeIndex={activeIndex}
                        src={finalPdfUrl}
                        type="pdf"
                        className="h-full"
                        fit="height"
                    />
                )}
            </div>
            <div className="flex h-full items-center">
                {hasNavigation && (
                    <IconButton
                        title="Next Page"
                        disabled={!hasNext}
                        onClick={onNext}
                    >
                        <ChevronRightIcon width="20" height="20" />
                    </IconButton>
                )}
            </div>
        </div>
        <div className="w-[300px] pl-4 fill-current shrink-0 flex flex-col h-full justify-between">
            <div>
                {!frozen && (
                    <>
                        <h3 className="mb-4 text-xl">Show/hide in layout</h3>
                        {settingsContent}
                    </>
                )}
            </div>
            <ApprovalButton
                budget={budget}
                project={project}
                params={getParams()}
                onClose={onClose}
            />
        </div>
    </div>
);

export default Desktop;
